import { generateRequest } from '.';

export const Action = {
  Nearby: {
    NearbyPending: 'Nearby_PENDING',
    NearbyCompleted: 'Nearby_FULFILLED',
    NearbyFailed: 'Nearby_FAILED',
  },
};

export const fetchNearbyStationsById = stationId => generateRequest({
  endpoint: `/assets-v2/api/stations/${stationId}/nearby`,
  types: [
    Action.Nearby.NearbyPending,
    Action.Nearby.NearbyCompleted,
    Action.Nearby.NearbyFailed,
  ],
});
